import { _ as e } from "./main64.js";
var a = e;
function t() {
  this.__data__ = a ? a(null) : {}, this.size = 0;
}
var _ = t;
export {
  _
};
